import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Full Name", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "Email Address", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "Account Role", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableHeader = _resolveComponent("TableHeader")!
  const _component_Selection = _resolveComponent("Selection")!
  const _component_TableRow = _resolveComponent("TableRow")!
  const _component_TableList = _resolveComponent("TableList")!

  return (_openBlock(), _createBlock(_component_TableList, { class: "grid-cols-3" }, {
    default: _withCtx(() => [
      _createVNode(_component_TableHeader, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }),
      (_ctx.users.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.users, (user) => {
            return (_openBlock(), _createBlock(_component_TableRow, {
              key: user.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(user.fullName), 1),
                _createElementVNode("div", null, _toDisplayString(user.email), 1),
                _createElementVNode("div", null, [
                  _createVNode(_component_Selection, {
                    "onUpdate:value": ($event: any) => (_ctx.updateRole(user.id, $event)),
                    value: user.role,
                    options: _ctx.roles
                  }, null, 8, ["onUpdate:value", "value", "options"])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}